import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import type { RadioButtonClickEvent } from "primeng/radiobutton";

@Component({
    selector: 'medsurf-design-input-radio-button',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './radio-button.input.design.html',
    styleUrls: ['./radio-button.input.design.scss'],
    standalone: false
})
export class RadioButtonInputDesign {
  @Input() formField = true;
  @Input({ required: true }) name!: string;
  @Input() inputClass = undefined;
  @Input() label?: string;
  @Input() disabled = false;
  @Input() labelTop = false;
  @Input() inputGroup = false;
  @Input({ required: true }) model!: any;
  @Input({ required: true }) value!: any;
  @Output() valueChange = new EventEmitter<RadioButtonClickEvent>();
}
